import { HtmlStepperAgentChat } from '../AgentChat/HtmlStepperAgentChat';
import { useHtmlStepperEditor } from './HtmlStepperEditorContext';

export const HtmlStepperEditorSidebar = () => {
  const { state, data, agentActions } = useHtmlStepperEditor();
  const { sidebarCollapsed, isVisualEditMode, setIsVisualEditMode } = state;
  const { formId, agentSession } = data;
  const { agentChanges } = agentSession;
  const {
    agentAcceptChange,
    agentDiscardChange,
    agentAcceptAllChanges,
    agentDiscardAllChanges,
    agentChangeClick,
  } = agentActions;

  return (
    <div
      className={`flex flex-col bg-white transition-all duration-300 ease-in-out ${
        sidebarCollapsed
          ? 'w-0 -translate-x-full overflow-hidden opacity-0'
          : 'w-96 translate-x-0 opacity-100'
      }`}
    >
      {!sidebarCollapsed && (
        <div className="flex h-full flex-col bg-linear-to-b from-[#F7F5FF] to-[#E5EEFF]">
          <HtmlStepperAgentChat
            formId={formId}
            changes={agentChanges}
            onChangeClick={agentChangeClick}
            onAcceptChange={agentAcceptChange}
            onDiscardChange={agentDiscardChange}
            onAcceptAllChanges={agentAcceptAllChanges}
            onDiscardAllChanges={agentDiscardAllChanges}
            isVisualEditMode={isVisualEditMode}
            onToggleVisualEdit={() => setIsVisualEditMode(!isVisualEditMode)}
          />
        </div>
      )}
    </div>
  );
};
